module.exports = __webpack_public_path__ + "media/process/Process4-9acb3971.png";